import { Button, ButtonGroup } from "@chakra-ui/react"
import { useEffect, useState } from "react"

export default function Options({ options = [], size = 'sm', defaultSelected = false, onChange = () => {}, ...props }){
    const [ selected, setSelected ] = useState(defaultSelected)

    useEffect(() => { onChange(selected) }, [selected])

    return <ButtonGroup variant="ghost" colorScheme="orange" size={size} {...props}>{ options.map(item => <Option key={item.value} selected={selected} onChange={setSelected} {...item} />) }</ButtonGroup>
}

const Option = ({ value, selected, onChange = () => {}, ...props }) => {
    return <Button variant={selected === value && 'solid'} onClick={() => onChange(value)} {...props} />
}